import { DataTable, FormLabel, Heading, Loader, Select } from "@/components";
import { Button, Input } from "@/components/ui";
import useOwners from "./useOwners";
import { ArrowDownToLine, ArrowUpFromLine, History, Search } from "lucide-react";
import { ResetPassword } from "@/pages";

const Owners = () => {
  const { isMobile, onAdd, globalFilter, setGlobalFilter, communityOptions, isAllCommunities, columns, onRowClick,
    isCommunityLoading, communityId, onCommunityChange, isLoading, usersGridData, hasAddPermission, communityKey,
    isTemplateDownloading, isBulkDownloading, downloadTemplate, onBulkDownload, onBulkUpload, onUploadHistory,
    openResetDialog, setOpenResetDialog, selectedRow, pageNumber, pageSize, setPageNumber,
    setPageSize, sorting, setSorting
  } = useOwners();

  return (
    <div className="p-4 md:p-6">
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading
            title="User Master Data"
            // breadcrumbData={breadcrumbData}
          />
          {isMobile && hasAddPermission ? <Button onClick={onAdd}>+ Add User</Button> : <></>}
        </div>
        <div className="flex flex-row items-center gap-4">
          <div className="relative w-full sm:w-72 sm:min-w-72 sm:max-w-72 shrink-0">
            <FormLabel>Select Community</FormLabel>
            <Select
              key={communityKey}
              options={communityOptions}
              value={communityId}
              onChange={onCommunityChange}
              className="h-[36px] w-full"
              disabled={isCommunityLoading}
            />
          </div>
          <Input
            type="text"
            placeholder="Search"
            value={globalFilter ?? ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="w-full sm:w-72 bg-white h-[40px]"
            startIcon={<Search className="w-4 h-4" />}
          />
          {!isMobile && hasAddPermission && (
            <Button onClick={onAdd}>+ Add User</Button>
          )}
        </div>
      </div>

      {isLoading ? <Loader /> :
        <>
          <div className="my-5 flex flex-wrap items-center justify-end">
            <Button variant="ghost" className="text-gray-500" disabled={isAllCommunities || isBulkDownloading} onClick={onBulkDownload}><ArrowDownToLine /> Bulk Download</Button>
            <Button variant="ghost" className="text-gray-500" disabled={isAllCommunities || isTemplateDownloading} onClick={downloadTemplate}><ArrowDownToLine /> Download Template</Button>
            <Button variant="ghost" className="text-gray-500" disabled={isAllCommunities || isTemplateDownloading || isBulkDownloading} onClick={onBulkUpload}><ArrowUpFromLine /> Bulk Upload</Button>
            <Button variant="ghost" className="text-gray-500" disabled={isAllCommunities} onClick={onUploadHistory}><History /> Upload History</Button>
          </div>
          <DataTable
            data={usersGridData?.data || []}
            columns={columns}
            pageNumber={pageNumber}
            pageSize={pageSize}
            setPageNumber={setPageNumber}
            setPageSize={setPageSize}
            totalPages={Math.ceil(usersGridData?.total / pageSize)}
            totalRecords={usersGridData?.total}
            serverSidePagination={true}
            sorting={sorting}
            onSortingChange={setSorting}
            onRowClick={onRowClick}
          />
        </>
      }
      <ResetPassword open={openResetDialog} setOpen={setOpenResetDialog} selectedUser={selectedRow} />
    </div>
  )
}

export default Owners;
